module.exports = __webpack_public_path__ + "/login_ui/img/np-aec553b1fa62db08220d57d6e3040aa4.svg";